import React from 'react'
import { Link } from 'react-router-dom'

function Pricing() {
  return (
    <div className="container-fluid  backdropsets_blur">
        <div className="row paln_bg">
            <div className="col-md-12">
                <div className="d-flex justify-content-center">
                    <h2 className="text-center mt-5 fw-bold col-md-10 anton">
                       Your  <span className="Features">
Superhuman  </span>
                   suite </h2>
                </div>
                <div className="row  justify-content-center mt-5">
                    <div className="col-11 col-md-12 col-lg-11 ">
                        <div className="row valuepack justify-content-center p-2 p-md-0">
                            <div className="col-md-5 mb-4 p-0 m-0">
                                <div className="plan_card m-0">
                                    <div className="row h-100 align-content-between">
                                        <div className="col-12">
                                            <div className="d-flex align-items-center gap-2 mb-3">
                                                <small className=" plans_title">Basic Plan</small>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <h4 className=" fw-bold fs-2 text-primary">₹199</h4><span className="ms-2 text-primary fw-semibold">/user/month</span>
                                            </div>
                                            <p className="fs-16">For small teams or basic monitoring needs</p>

                                        <div className="col-md-12 py-3">
                                            <Link to='https://view.loov.in/sign-up' target="_blank" className="btn_adujst">
                                                <button className="text-white btn_trails" type="submit">Start Free Trail</button>
                                            </Link>
                                        </div>
                                            <div className="d-flex align-items-center gap-2 mb-4">
                                                <img src={require("../assets/bluechecklist.svg").default} alt=''/>
                                                <p className="mb-0">Automatic Screenshots</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 mb-4">
                                                  <img src={require("../assets/bluechecklist.svg").default} alt=''/>
                                                <p className="mb-0">1 Month Data Retention</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 mb-4">
                                                   <img src={require("../assets/bluechecklist.svg").default} alt=''/>
                                                <p className="mb-0">Basic Support</p>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-5 mb-4 p-0 m-0 h-100 position-relative">
                                    <div className="value-pack ">Value Pack</div>

                                <div className="plan_card_1">
                                    <div className="d-flex align-items-center gap-2 mb-3">
                                        <small className=" plans_title">Pro Plan</small>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <h4 className=" fw-bold fs-2 ">₹349</h4><span className="ms-2 fw-semibold">/user/month</span>
                                    </div>
                                    <p className="fs-16 ">For full visibility and performance tracking</p>
                                                                            <div className="col-md-12 py-3">
 <Link to='https://view.loov.in/sign-up' target="_blank" className="col-md-12 mt-5">
                                        <button className="text-white pro_btn_trails" type="submit">Start Free Trail</button>
                                    </Link></div>

                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">Automatic Screenshots</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">Live Screen View</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">Camera Snapshots</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default}alt=''/>
                                        <p className="mb-0 ">Web & URL Tracking</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">Mouse & Keyboard Activity</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">3 Months Data Retention</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <img src={require("../assets/blackchecklist.svg").default} alt=''/>
                                        <p className="mb-0 ">Priority Support</p>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      
        <div className="row p-0 m-0">

            <div className='col-md-12 p-0 py-5'>
                <div className='trail_box py-5 px-2'>
                    <h1>Start Monitoring Your Team Now!</h1>
                                <p>No More Guesswork — Track Activity, Boost Productivity, And Support Your Team Effortlessly.</p>
                    <div className='d-flex justify-content-center'>
                        {/* <Link to='https://view.loov.in/sign-up' target="_blank" className='trail_btn fs-14'>
                            Start Your Free Trial
                        </Link> */}
 <a href='https://view.loov.in/sign-up' class="allhovebtn allhovebtn--svg js-animated-button text-white">
                                        <span class="allhovebtn--svg__label">Start Your Free Trial</span>
                                        <svg width="190" x="0px" y="0px" viewBox="0 0 60 60" class="allhovebtn--svg__circle">
                                          <circle fill="#9FCBFF" cx="30" cy="30" r="28.7" class="js-discover-circle"></circle>
                                        </svg>
                                        <svg x="0px" y="0px" preserveAspectRatio="none" viewBox="2 29.3 56.9 13.4" width="190" class="allhovebtn--svg__border">
                                          <g class="allhovebtn--svg__border--left js-discover-left-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9H9c0,0-6.2-0.3-6.2-5.9S9,30.1,9,30.1h21.4"></path>
                                          </g>
                                          <g class="allhovebtn--svg__border--right js-discover-right-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9h21.5c0,0,6.1-0.4,6.1-5.9s-6-5.9-6-5.9H30.4"></path>
                                          </g>
                                        </svg>
                                    </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Pricing
